<template>
  <div>
    <div class="book-wrapper">
      <img class="book" src="@/assets/book.svg" />
      <div class="book-content-area">
        <p class="title">
          {{
            selectedMission.mission_title
              ? selectedMission.mission_title
              : "名称未設定のミッションです"
          }}
        </p>
        <p>
          <img class="point-img" src="@/assets/point.png" />
          <span class="point">{{ quizMissonPointSum }}</span>
        </p>
      </div>
    </div>
    <div class="mission-content-area">
      <p class="title">ミッション詳細</p>
      <div class="description">
        {{
          selectedMission.mission_title
            ? selectedMission.mission_title
            : "説明文未設定のミッションです"
        }}
      </div>
      <hr />
      <div v-if="selectedMission.mission_image_url !== ''">
        <img class="mission-img" :src="selectedMission.mission_image_url" />
        <hr />
      </div>
      <div class="description">
        {{
          selectedMission.mission_text
            ? selectedMission.mission_text
            : "説明文未設定のミッションです"
        }}
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
export default {
  name: "quiz-mission-info",
  props: {
    selectedMission: { type: Object, require: true },
  },
  computed: {
    quizMissonPointSum() {
      return this.selectedMission.quiz_items.reduce(
        (sum, quizItem) => sum + quizItem.point,
        0,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.book {
  width: 98vw;
  margin-left: 1vw;
}
.book-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 700/400;
  z-index: -1;

  .book {
    width: 95vw;
    position: absolute;
    z-index: -1;
  }

  .book-content-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 80vw;
    p {
      margin: 0.5rem 0;
      display: flex;
    }

    .title {
      font-size: 1rem;
      text-align: center;
    }

    .point-img {
      width: 32px;
    }
    .point {
      font-weight: 500;
      font-size: 1.25rem;
    }
  }
}
.mission-img {
  width: 100%;
}
.mission-content-area {
  padding: 0 1.25rem;
}

hr {
  border: none;
  background: #ddd;
  height: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/QuizMission/Info.vue